const Timestamp = ({ value }: { value: string }) => <time dateTime={value}>{new Date(value).toLocaleString()}</time>

export default Timestamp
